module.exports = __webpack_public_path__ + "img/cloth_g1_sleeve_02.5dd32aab.svg";